(function($){
	var tint = setInterval(function(){
		$('.mce-text').each(function(){
			if($(this).html() == 'Dodaj medium'){
				$(this).closest('div').remove();
				clearInterval(tint);
			}
		})
	}, 200)
	$('body').on('keyup change', '.meta-update', function(){
		update_crm_meta($(this).attr('data-meta-key'), $(this).val(), $(this).attr('data-pid'), $(this).attr('data-validation'));
		$(this).closest('.edit-inline').find('.value-element').html($(this).val().replace("\r", '<br />'));
	});
	$('body').on('change', '.dictionary-update', function(){
		update_crm_dictionary($(this).attr('data-meta-key'), $(this).val(), $(this).attr('data-pid'), $(this).attr('id'));
		$(this).closest('.edit-inline').find('.value-element').html($(this).val().replace("\r", '<br />'));
	});

	$('.add-dictionary-container form').on('submit', function(e){
        e.preventDefault()
	    add_to_dictionary($(this).attr('id'), $(this).find('input').attr('data-id'), $(this).find('input').val());
    });
	$('.add-dictionary').on('click', function(e){
	    e.preventDefault();
	    $(this).prev('div').toggle();
    });

	$(window).on('resize', function(){
		if($('.JColResizer').length > 0){
			$('.JColResizer th, .JColResizer td').each(function(){
				$(this).removeAttr('style')
			})
		}
	});
	$(document).ready(function(){
		// $('<div class="custom-input"><input type="number" name="day"><input type="number" name="month"><input type="number" name="year"></div>').insertBefore('[type="datepicker"]');
		$('[type="datepicker"], [data-name="data_urodzenia"] input, [data-name="data_zakonczenia"] input, [data-name="data_rozpoczecia"] input').datepicker({
			changeMonth: true, // Włącz opcję wyboru miesiąca
			changeYear: true,
			yearRange: "1900:2024",
			dateFormat: "dd-mm-yy",
		});

		setInterval(function(){
			$('[data-name="data_urodzenia"] input').attr('readonly', false);
		}, 1000)
	});

	$(document).ready(function(){
		var originalSize = $('div').css('font-size');
		// reset
		$(".resetMe").click(function(){
			$('div').css('font-size', originalSize);
		});

		// Increase Font Size
		$(".increase").click(function(){
			var div = $('div').css('font-size'), table = $('table').css('font-size'), td = $('td').css('font-size'), th = $('th').css('font-size');
			var div = parseFloat(div)*1.05;
			$('div').css('font-size', div);
			if($('.JColResizer').length > 0){
				$('.JColResizer th, .JColResizer td').each(function(){
					$(this).removeAttr('style')
				})
			}
			return false;
		});

		// Decrease Font Size
		$(".decrease").click(function(){
			var currentFontSize = $('div').css('font-size');
			var currentSize = $('div').css('font-size');
			var currentSize = parseFloat(currentSize)*0.95;
			$('div').css('font-size', currentSize);
			if($('.JColResizer').length > 0){
				$('.JColResizer th, .JColResizer td').each(function(){
					$(this).removeAttr('style')
				})
			}
			return false;
		});
		setTimeout(function(){
			$("#is-resizable, .is-resizable").colResizable({
				liveDrag: true,
				partialRefresh: true,
				resizeMode: 'flexible',
				useLocalStorage: true,
				postbackSafe: true,
			});
			console.log('resizable')
		}, 500)
		$('.screen-options .screen-option').on('click', function(){
			$("#is-resizable").colResizable('destroy');
			setTimeout(function(){
				$("#is-resizable").colResizable({
					liveDrag: true,
					partialRefresh: true,
					resizeMode: 'flexible',
					useLocalStorage: true,
					postbackSafe: true,
				});
			}, 500)
		});

		// $('.meta-update-inline input').each(function(){
		// 	if($(this).val() != ''){
		// 		var lng = $(this).val().length;
		// 		$(this).css('width', lng * 9.5 + 'px');
		// 	}
		// });
		$('.screen-options-container .toggle-screen-options').on('click', function(){
			$('.screen-options-container .screen-options').toggleClass('visible');
			var table_id = $('.screen-options-container').attr('data-table');
			$('.screen-options .screen-option').each(function(){
				var th_class = 'col-' + $(this).find('input').val();
				$(this).find('span').html($(table_id).find('th.' + th_class).attr('data-name'));
			})
		});
		$('.date-mask').inputmask('yyyy-mm-dd', { 'placeholder': 'yyyy-mm-dd' });
		$('#same-address').on('click', function(){
			if($(this).prop('checked') == true){
				$('.address-cor').slideUp(250);
			}
			else{
				$('.address-cor').slideDown(250);
			}
		});
		if($('#same-address').length > 0){
			if($('#same-address').prop('checked') == true){
				$('.address-cor').hide();
			}
			else{
				$('.address-cor').show();
			}
		}
		if($('.clients-dt').length) {

			var table = $('.clients-dt').DataTable({
				"paging": true,
				"lengthChange": true,
				"searching": true,
				"ordering": true,
				"info": true,
				"autoWidth": false,
				"responsive": true,
				"order": [[ 2, "desc" ]],
				"language": {
					"lengthMenu": "Pokaż _MENU_ rekordów na stronę",
					"zeroRecords": "Wszystkie wyniki",
					"info": "Strona _PAGE_ z _PAGES_",
					"infoEmpty": "Brak",
					"infoFiltered": "(filtrowanie z _MAX_ łącznie)"
				},
				"lengthMenu": [[10, 25, 50, 100, 500, 1000, 5000, -1], [10, 25, 50, 100, 500, 1000, 5000, "Wszystko"]],
				"columnDefs": [
					{
						"targets": [ 12, 13 ],
						"visible": false,
					},
					{
						"targets": [ 0 ],
						"orderable": false,
					},
				]
			});
			$('body').on('click', '.clients-dt .has-checkbox input', function(){
				var json = jQuery.parseJSON($('#selected-clients').val());
				if($(this).prop('checked')) {
					json.push($(this).val());
				}
				else{
					var index = json.indexOf($(this).val());
					if (index !== -1) {
						json.splice(index, 1);
					}
				}
				$('#selected-clients').val(JSON.stringify(json));
				console.log(json);
			// 	$('#selected-clients').val('');
			// 	var current_page = table.page.info().page, selected_clients = '';
			// 	var int = setInterval(function(){
			// 		$('.clients-dt .has-checkbox').each(function(){
			// 			if($(this).find('input').prop('checked')){
			// 				selected_clients = selected_clients + $(this).find('input').val() + ',';
			// 			}
			// 		});
			// 		$('.pagination .next').click();
			// 		if($('.pagination .next').hasClass('disabled')){
			// 			table.page(current_page).draw(false);
			// 			clearInterval(int);
			// 			setTimeout(function(){
			// 				$('#selected-clients').val(selected_clients);
			// 			}, 10)
			// 		}
			// 	}, 1);
			});
			$('.check-visible').on('click', function(){
				var ckc = $(this).prop('checked');
				var current_page = table.page.info().page, selected_clients = '';
				table.page('first').draw(false);
				$('.loader').fadeIn(250);
				$('.clients-dt .has-checkbox').each(function(){
					if(ckc != $(this).find('input').prop('checked')){
						$(this).find('input').click();
					}
				});
				var int = setInterval(function(){
					$('.clients-dt .has-checkbox').each(function(){
						if(ckc != $(this).find('input').prop('checked')){
							$(this).find('input').click();
						}
					});
					$('.pagination .next').click();

					if($('.pagination .next').hasClass('disabled')){
						$('.clients-dt .has-checkbox').each(function(){
							if(ckc != $(this).find('input').prop('checked')){
								$(this).find('input').click();
							}
						});
						table.page(current_page).draw(false);
						clearInterval(int);
						setTimeout(function(){
							$('.loader').fadeOut(250);
						}, 40)
					}
				}, 1);

			});
			$('.screen-options .column-list input').each(function(){
				if(!$(this).prop('checked')) {
					var column = table.column($(this).attr('data-column'));
					column.visible(!column.visible());
				}
			});
			$('body').on( 'click', '.screen-options .column-list input', function (e) {
				var cookie_value;
				if($(this).prop('checked') == true){
					cookie_value = 1;
				}
				else {
					cookie_value = 0;
				}
				var tableclass = $(this).closest('.column-list').attr('data-table');
				// Get the column API object
				var column = table.column( $(this).attr('data-column') );
				column.visible( ! column.visible() );
			} );
			// var filter1 = createFilter(table, [0, 1]);
			// var filter2 = createFilter(table, [2]);

			// filter1.appendTo(".search-filters .row");
			// filter2.appendTo(".search-filters .row");

		}
		$('.search-filters #name-search').on('keyup', function(){
			table.column(1).search($(this).val()).draw();
		});
		$('.search-filters #birthday-search').on('keyup', function(){
			table.column(2).search($(this).val()).draw();
		});
		$('.search-filters #address-search').on('keyup', function(){
			table.column(3).search($(this).val()).draw();
		});
		$('.search-filters #phone-search').on('keyup', function(){
			table.column(4).search($(this).val()).draw();
		});
		$('.search-filters #email-search').on('keyup', function(){
			table.column(5).search($(this).val()).draw();
		});
		$('.search-filters #newsletters label').on('click', function(){
			var txt = '';
			$('.search-filters #newsletters label').each(function () {
				if($(this).find('input').prop('checked') == true){
					txt = txt + $(this).find('input').val();
				}
			});
			table.column(12).search(txt).draw();
		});
		$('.search-filters #assigned label').on('click', function(){
			var txt = '';
			$('.search-filters #assigned label').each(function () {
				if($(this).find('input').prop('checked') == true){
					txt = txt + $(this).find('input').val() + ' ';
				}
			});
			table.column(13).search(txt).draw();
		});
		function createFilter(table, columns) {
			var input = $('<div class="col-2"><input type="text" class="form-control" /></div>').on("keyup", function() {
				table.draw();
			});

			$.fn.dataTable.ext.search.push(function(
				settings,
				searchData,
				index,
				rowData,
				counter
			) {
				var val = input.val().toLowerCase();

				for (var i = 1, ien = columns.length; i < ien; i++) {
					if (searchData[columns[i]].toLowerCase().indexOf(val) !== -1) {
						return true;
					}
				}

				return false;
			});

			return input;
		}
		var default_sort = 0, default_sort_direction = 'asc';
		if($('.auto-dt').attr('data-default-order')){
			default_sort = $('.auto-dt').attr('data-default-order');
			default_sort_direction = $('.auto-dt').attr('data-default-order-direction');
		}
		$('.auto-dt').DataTable({
			"paging": true,
			"lengthChange": true,
			"searching": false,
			"ordering": true,
			"info": true,
			"autoWidth": false,
			"responsive": true,
			"order": [[ default_sort, default_sort_direction ]],
			"language": {
				"lengthMenu": "Pokaż _MENU_ rekordów na stronę",
				"zeroRecords": "Wszystkie wyniki",
				"info": "Strona _PAGE_ z _PAGES_",
				"infoEmpty": "Brak",
				"infoFiltered": "(filtered from _MAX_ total records)"
			}
		});
		$('[data-toggle="tooltip"]').tooltip();
	});
	$('.show-remove-form').on('click', function(e){
		e.preventDefault();
		$(this).slideUp(250);
		$('.remove-client').slideDown(250);
	});

	$('.stop-hide label').on('click', function(){
		$(this).closest('.dropdown').addClass('show');
		$(this).closest('.dropdown-menu').addClass('show');
	});
	// $('body').on('click', ':not(input):not(textarea):not(select)', function(){
	// 		$('.edit-inline').find('span').show();
	// 		$('.edit-inline').find('.has-meta-update').hide();
	//
	// });
	$('body').on('click', function(){
		const $clickedElement = $(event.target);
		const $textarea = $('.has-meta-update');
		const isTextarea = $clickedElement.is($textarea);
		if (!isTextarea && !$clickedElement.closest('textarea').length) {
			// Ukryj textarea
			// $('.edit-inline').find('span').show();
			// $('.edit-inline').find('.has-meta-update').hide();
		}

	});
	$('body').on('click', '.edit-inline', function(e){
		e.preventDefault();
		var th = $(this);
		setTimeout(function(){
			// $('.edit-inline').find('span').show();
			// $('.edit-inline').find('.has-meta-update').hide();
			// th.find('span').hide();
			// th.find('.has-meta-update').show();
			// th.find('.has-meta-update').find('input, textarea').focus();
		}, 10)
	});
	$('.edit-window, .last-comment').on('click', function(){
		$(this).next('.window-editor').css('display', 'flex');
	});
	$('body').on('click', '.form-window-editor .close', function(e){
		e.preventDefault();
		$(this).closest('.window-editor').fadeOut(300);
	})


})(jQuery);
function handleInput(input) {
	var currentValue = input.value.replace(/-/g, '');
	if(currentValue.length == 0){
		$(input).next('.placeholder').html('__-__-____').css('padding-left', 0);
	}
	if(currentValue.length == 1){
		$(input).next('.placeholder').html('_-__-____').css('padding-left', '8px');
	}
	if(currentValue.length == 2){
		$(input).next('.placeholder').html('-__-____').css('padding-left', '16px');
	}
	if(currentValue.length == 3){
		$(input).next('.placeholder').html('_-____').css('padding-left', '28px');
	}
	if(currentValue.length == 4){
		$(input).next('.placeholder').html('-____').css('padding-left', '36px');
	}
	if(currentValue.length == 5){
		$(input).next('.placeholder').html('___').css('padding-left', '48px');
	}
	if(currentValue.length == 6){
		$(input).next('.placeholder').html('__').css('padding-left', '56px');
	}
	if(currentValue.length == 7){
		$(input).next('.placeholder').html('_').css('padding-left', '64px');
	}
	if(currentValue.length == 8){
		$(input).next('.placeholder').html('').css('padding-left', '70px');
	}
	// if(currentValue.length == 10){
	// 	$(input).next('.placeholder').html('').css('padding-left', '70px');
	// }
	console.log(currentValue.length);
	// input.value = formattedValue;
}

$(document).on('click', 'td, th', function(e) {
	// Sprawdź, czy kliknięty element nie jest bezpośrednio checkboxem
	if (!$(e.target).is('input[type="checkbox"]')) {
		// Znajdź checkbox w środku td/th i kliknij go
		$(this).find('input[type="checkbox"]').trigger('click');
	}
});




function formatDate(input) {
	var value = input.value.replace(/\D/g, '');
	var formattedValue = '';

	if (value.length <= 2) {
		formattedValue = value;
	} else if (value.length <= 4) {
		formattedValue = value.substring(0, 2) + '.' + value.substring(2);
	} else if (value.length <= 8) {
		formattedValue = value.substring(0, 2) + '.' + value.substring(2, 4) + '.' + value.substring(4, 8);
	} else {
		formattedValue = value.substring(0, 2) + '.' + value.substring(2, 4) + '.' + value.substring(4, 8);
	}

	input.value = formattedValue;
}